import React from "react";
import { persistor } from "store";
import Button from "common/components/CustomButtons/Button.jsx";
import config from "config";

const ErrorBox = props => (
  <div className="centeredDiv">
    <h2>Oops! Something went wrong.</h2>
    <br />
    <br />
    {props.children}
    <br />
    <br />
    {props.reload ? (
      <Button
        key="reloadButton"
        fullWidth
        onClick={() => {
          try {
            window.localStorage.removeItem("persist:root");
          } catch (e) {
            console.log(e.message);
          }
          if (persistor != null) {
            persistor.pause();
            persistor.flush().then(() =>
              persistor.purge().then(() => {
                window.open(
                  window.location.origin + config.MYACCOUNT.APP_PATH,
                  "_self"
                );
              })
            );
          } else {
            window.open(
              window.location.origin + config.MYACCOUNT.APP_PATH,
              "_self"
            );
          }
        }}
        color="primaryLightBlue"
      >
        Reload Page
      </Button>
    ) : null}
  </div>
);

export default ErrorBox;
